import React from 'react';
import { Navigation } from '../ReactCalendar';
import { nextWeek, prevWeek } from './utils';
import { Col, Flex, Text } from '@keyslabor/shared/ui';
import Grid from '@keyslabor/shared/ui/layout/Grid';
import { navBarCompactStyles } from './styles';
import { CalendarNavigationProps } from './types';
import Icon from '@keyslabor/shared/ui/Icon';
import { Tooltip } from 'antd';
import {
  CompactCalendarIcon,
  CompactArrowLeftIcon,
  CompactArrowRightIcon,
} from '@keyslabor/shared/assets/svgComponents';
import useCalendarUtils from '@/hooks/useCalendarUtils.ts';
import { useCalendarConfig } from '@/hooks/useCalendarConfig.ts';
import { substituteWeekNumberInFormattedString } from '@/utils/calendarUtils.ts';

export default function CalendarNavigationCompact({
  width,
  height,
  value,
  onDateSelect,
  onNavClick,
  disableNext,
  disablePrev,
  disableNextTip,
  disablePrevTip,
  withCalendarIcon = true,
  weekSelect,
  showYear = true,
  showIcon = true,
  formatedDate,
  color,
  fullWidth,
}: CalendarNavigationProps) {
  const utils = useCalendarUtils();
  const calendarConfig = useCalendarConfig();
  const { curWeek, year } = utils.getFormattedDateNames(value);
  // console.log('CalendarNavigationCompact', {
  //   curWeek, year, value
  // })
  return (
    <Grid
      width="100%"
      css={navBarCompactStyles({ fullWidth })}
      gridAutoFlow="column"
      gridAutoColumns={fullWidth && '100%'}
      flexCenter
    >
      <Navigation
        navigationLabel={() => {
          return (
            <Col
              width={width || '100%'}
              height={height || '100%'}
              px="10px"
              gridAutoColumns="1fr max-content 1fr"
              opacity={disablePrev && 0.5}
              gap="10px"
            >
              <Tooltip title={disablePrev && disablePrevTip}>
                <Flex
                  width="100%"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!disablePrev) {
                      onDateSelect(prevWeek(value));
                    }
                  }}
                >
                  <Icon>
                    <CompactArrowLeftIcon fill={color} />
                  </Icon>
                </Flex>
              </Tooltip>
              <Col flexCenter gap="6px" onClick={onNavClick}>
                {formatedDate ? (
                  <Text color="#202124">
                    {substituteWeekNumberInFormattedString(
                      formatedDate,
                      calendarConfig.weeksOffset
                    )}
                  </Text>
                ) : (
                  <Text color="#202124">
                    {substituteWeekNumberInFormattedString(
                      weekSelect
                        ? showYear
                          ? `Week ${curWeek}, ${year}`
                          : `Week ${curWeek}`
                        : `${utils.getNiceDate(value)}, ${year}`,
                      calendarConfig.weeksOffset
                    )}
                  </Text>
                )}
                {showIcon && (
                  <Icon ml="2px">
                    <CompactCalendarIcon fill={color} />
                  </Icon>
                )}
              </Col>
              <Tooltip title={disableNext && disableNextTip}>
                <Flex
                  opacity={disableNext && 0.5}
                  justifyContent="flex-end"
                  onClick={() => {
                    if (!disableNext) {
                      onDateSelect(nextWeek(value));
                    }
                  }}
                >
                  <Icon>
                    <CompactArrowRightIcon fill={color} />
                  </Icon>
                </Flex>
              </Tooltip>
            </Col>
          );
        }}
        nextLabel={null}
        prevLabel={null}
        key={`${Math.random()}-${value.valueOf()}`}
        next2Label={null}
        prev2Label={null}
        activeStartDate={value}
        drillUp={() => null}
        view="month"
        views={['month']}
        setActiveStartDate={onDateSelect}
      />
    </Grid>
  );
}
